import React from 'react';
import styled from '@emotion/styled';
import { devices, Spacing, Stack, Text } from './common';
import { PhoneIcon, EmailIcon } from './SVG';
import { ContactPerson } from './../@types/types';
import ProfilePhotoPlaceholder from '../../static/assets/profile_photo_placeholder.png';

type Props = {
  contact: ContactPerson;
};

const Card = ({
  contact: { Email, Name, Phone, PhoneNumber, Title, Picture },
}: Props) => {
  const phone = Phone || PhoneNumber;

  return (
    <Container>
      <ImageContainer>
        <Image src={Picture?.publicURL ?? ProfilePhotoPlaceholder} />
      </ImageContainer>
      <ContentContainer>
        <ContentStack axis={'y'} spacing={'default'}>
          <NameField variant={'title-3'}>{Name}</NameField>
          <TitleField variant={'body'}>{Title}</TitleField>

          {Email?.trim() && (
            <InfoContainer>
              <EmailIcon />
              <Spacing amount={'default'} />
              <InfoText variant={'body'}>{Email}</InfoText>
            </InfoContainer>
          )}

          {phone?.trim() && (
            <InfoContainer>
              <PhoneIcon />
              <Spacing amount={'default'} />
              <InfoText variant={'body'}>{phone}</InfoText>
            </InfoContainer>
          )}
        </ContentStack>
      </ContentContainer>
    </Container>
  );
};

export default Card;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex: 0 0 45%;
  box-shadow: 0px 5px 15px rgba(2, 38, 64, 0.1);
  background-color: white;
  border-radius: 5px;
  border-top: 1px solid #eee;
  padding: 24px 34px;
  align-items: center;
  margin-right: ${(props) => props.theme.spacing.default};
  margin-bottom: ${(props) => props.theme.spacing.medium};

  @media ${devices.laptop} {
    flex: 0 0 100%;
    max-width: 90%;
  }

  @media ${devices.mobileXL} {
    flex-direction: column;
    margin-right: 0px;
    max-width: 100%;
  }
`;

const ImageContainer = styled.div`
  height: 130px;
  width: 130px;
  min-height: 130px;
  min-width: 130px;
  margin-right: ${(props) => props.theme.spacing.default};

  @media ${devices.mobileXL} {
    margin-right: 0px;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
`;

const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const InfoText = styled(Text)`
  word-wrap: break-word;

  @media ${devices.mobileXL} {
    width: 70%;
  }
`;

const NameField = styled(Text)`
  @media ${devices.mobileXL} {
    text-align: center;
  }
`;

const TitleField = styled(Text)`
  @media ${devices.mobileXL} {
    text-align: center;
  }
`;

const ContentStack = styled(Stack)`
  width: 100%;
`;
